/* eslint-disable no-alert */
import React from "react";
class InboxTaskItem extends React.Component {
	constructor(props) {
		super(props);
		var now = new Date();
		if (this.props.item.taskDetails.reminder != null
			&& this.props.item.taskDetails.reminder.time != null) {
			var reminderTime = new Date(this.props.item.taskDetails.reminder.time);
			if (reminderTime.getFullYear() === now.getFullYear()
				&& reminderTime.getDate() === now.getDate()
				&& reminderTime.getMonth() === now.getMonth())

				this.state = { class: "todaysreminder" };
			else if (reminderTime < now) {
				this.state = { class: "passedoutreminder" };
			} else
				this.state = { class: "scheduled" };
		}
		else
			this.state = { class: "not-scheduled" };
	}
	render() {
		var taskName = this.props.item.taskDetails.name;
		if (this.props.item.taskDetails.project !== undefined && this.props.item.taskDetails.project.name !== "") {
			taskName = taskName + "===>(" + this.props.item.taskDetails.project.name + ")"
		}
		return <tr className={this.state.class}>
			<td><span>{taskName}</span></td>
			<td> <button onClick={this.props.toggleDetails}>Toggle Details</button></td>
		</tr>
	}
}
export default InboxTaskItem;
/* eslint-enable no-alert */